<template>
<v-responsive>
    <v-data-table :items="buyers" :headers="headers" hide-default-footer>
        <template v-slot:item.companyName="{item}">
            {{ item.companyName[$i18n.locale] }}
        </template>
        <template v-slot:item.activityAreas="{item}">
            {{ item.activityAreas[$i18n.locale] }}
        </template>
        <template v-slot:item.introductions="{item}">
            <v-row justify="center">
                <v-col v-for="(introduction, index) in item.introductions" :key="index" cols="auto" class="pa-0 pr-2">
                    <v-icon v-if="introduction[$i18n.locale]" color="primary" @click="download(introduction[$i18n.locale])">{{ mdiArrowDownThinCircleOutline }}</v-icon>
                </v-col>
            </v-row>
        </template>
    </v-data-table>

    <pagination-component v-model="page" :count="pageCount" @input="search" class="mt-3"></pagination-component>
</v-responsive>
</template>
<script>
import api from "@/api";
import download from "downloadjs";
import { mdiArrowDownThinCircleOutline } from '@mdi/js';

import PaginationComponent from "../control/pagination-component.vue";
export default {
    components: {
        PaginationComponent
    },
    props: ["_fair"],
    data(){
        return {
            mdiArrowDownThinCircleOutline,

            page: 1,
            pageCount: 0,
            limit: 10,

            buyers: [],

            filter: {
                ...this.$attrs
            },

            headers: [
                { text: "업체명", align: "center", value: "companyName" },
                { text: "바이어유형", align: "center", value: "kind" },
                { text: "활동지역", align: "center", value: "activityAreas" },
                { text: "회사소개서", align: "center", value: "introductions" },
            ]
        }
    },
    mounted(){
        this.search();
    },
    methods: {
        download,
        async search(){
            let { summary, buyers } = await api.v1.fairs.buyers.gets(this.$props._fair, {
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.buyers = buyers;
        }
    }
}
</script>